import { fetchDataPromise } from '../index';

export const getPrismXSysInfo = (resolve, reject, token) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/getsysinfo', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      }
    });
  
    fetchDataPromise(req, 'getsysinfo', resolve, reject);
}

export const checkPrismXFirmOTA = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/checksystemfirm', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'checkPrismXFirmOTA', resolve, reject);
}

export const prismXFirmUpgrade = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/systemfirmupgrade', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    }
  });

  fetchDataPromise(req, 'systemfirmupgrade', resolve, reject);
}

export const localSoftwareUpdate = (resolve, reject, token, formData) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/localsoftwareupdate';
  let req = new Request(requestURL, {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Authorization' : token
      },
      body: formData
  });

  fetchDataPromise(req, 'localsoftwareupdate', resolve, reject)
}

export const saveSystemDate = (resolve, reject, token, date) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['settings'] + '/savesystemdate';
  let req = new Request(requestURL, {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Authorization' : token
      },
      body: date
  });

  fetchDataPromise(req, 'savesystemdate', resolve, reject)
}